import * as React from 'react';
import {
  SponsorshipContainer,
  SponsorshipHeadingContainer,
  SponsorshipHeading,
  MobileSponsorshipHeading,
  SponsorshipImageDesktop,
  SponsorshipImageMobile,
} from './SponsorshipSection.style';
import { icons } from '../../style/icons';

const SponsorshipSection = ({ heading }) => {
  return (
    <SponsorshipContainer>
      <SponsorshipHeadingContainer>
        <SponsorshipHeading>{heading}</SponsorshipHeading>
        <MobileSponsorshipHeading>{heading}</MobileSponsorshipHeading>
      </SponsorshipHeadingContainer>
      <SponsorshipImageDesktop
        src={icons.SPONSORSHIPS_DESKTOP.image}
        alt={icons.SPONSORSHIPS_DESKTOP.altText}
      />
      <SponsorshipImageMobile
        src={icons.SPONSORSHIPS_MOBILE.image}
        alt={icons.SPONSORSHIPS_MOBILE.altText}
      />
    </SponsorshipContainer>
  );
};

export default SponsorshipSection;
